import { DetailsDrawer } from "./details-drawer";

class FilterDrawer extends DetailsDrawer {
  constructor() {
    super();
    //implementation
  }

  
}

window.customElements.define('filter-drawer', FilterDrawer);